
class WebService {
    protocol: 'http:'|'https:'|'ws:'|'wss:'|'file:' = undefined;
    hostname: string = '';
    port: string = '';
    pathname: string = '';
    search: string = '';
    get host(): string { return `${this.hostname}${this.port}`; }
    get origin(): string { return `${this.protocol}//${this.host}`; }
    get href(): string { return `${this.origin}${this.pathname}${this.search}`; }
    
    constructor(options: any = {}) {
      this.protocol = options.protocol || this.protocol;
      this.hostname = options.hostname || this.hostname;
      this.port = options.port && `:${options.port}` || this.port;
      this.pathname = options.pathname || this.pathname;
      this.search = options.search && `?${options.search}` || this.search;
  
      return this;
    }
    
  }
  
  /**
   * TODO: Abstract this out into a class
   *    * Instantiate different environment instances.
   *    * Use in Postman as an environment configuration.
   *    * Example: { protocol: 'http(s)', domain: 'x.domain.com', 'v': 'v1' }
   */
  class Environment {
    type: 'PROD'|'SIT'|'UAT'|'DEMO'|'QA'|'DEV'|'MOCK'|'DockerLocal' = 'PROD';
    api: WebService = new WebService();
    data: any = { };
    get production(): boolean { return { 'PROD': true, 'QA': false, 'DEV': false, 'MOCK': false }[ this.type ]; }
  
    constructor(options: any = { type: 'PROD' }) {
      this.type = options.type;
      this.api = new WebService(options.api || this.api);
      this.data = options.data || this.data;
  
      return this;
    }
  
  }
  
  export { Environment, WebService };
  